module.exports = __webpack_public_path__ + "img/multifaced.9f8bfee3.png";